// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip__GiaNeazLkC{width:380px}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/conversations/components/table/components/rows/conversationRow/components/rowCells/status/components/agentPreference/conversationsTableStatusAgentPreference.module.scss"],"names":[],"mappings":"AAAA,qBACE,WAAA","sourcesContent":[".tooltip {\n  width: 380px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip__GiaNeazLkC`
};
export default ___CSS_LOADER_EXPORT___;
